// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainInfo__vA3FT {
  grid-column: 1;
}

.mainInfoTitle__rU5rx {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.mainInfoFields__gQwbv {
  height: calc(100% - 24px);
  margin-top: 10px;
  padding: 20px;
  display: flex;
  column-gap: 15px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.mainInfoPhoto__q51Lx {
  width: 80px;
  height: 80px;
  padding: 5px;
  border-radius: 50%;
}

.mainInfoRight__D6qF5 {
  padding-top: 10px;
}

.mainInfoText__zhHvC {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 8px;
}

.mainInfoTextName__onn8l {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-transform: capitalize;
  color: var(--tables-primary-row-text-main);
}

.mainInfoTextRole__f5bKQ {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
}

.mainInfoBtns__obMcA {
  margin-top: 5px;
  padding-top: 10.5px;
  display: flex;
  align-items: center;
  column-gap: 15px;
}
@media (max-width: 1300px) {
  .mainInfoBtns__obMcA {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 21px;
  }
}

.skeletonPhoto__PxiKP {
  border-radius: 50%;
}

.skeletonTextWrapper__ddtL7 {
  width: calc(100% - 95px);
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}

.skeletonText__uCbqg {
  width: 100%;
  display: block;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/components/MainInfo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,cAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,qDAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,iBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,0CAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAzEF;AA2EE;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,aAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;AAxEF;;AA2EA;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,cAAA;EACA,YAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.mainInfo {\n  grid-column: 1;\n}\n\n.mainInfoTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.mainInfoFields {\n  height: calc(100% - 24px);\n  margin-top: 10px;\n  padding: 20px;\n  display: flex;\n  column-gap: 15px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.mainInfoPhoto {\n  width: 80px;\n  height: 80px;\n  padding: 5px;\n  border-radius: 50%;\n}\n\n.mainInfoRight {\n  padding-top: 10px;\n}\n\n.mainInfoText {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.mainInfoTextName {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: capitalize;\n  color: var(--tables-primary-row-text-main);\n}\n\n.mainInfoTextRole {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n}\n\n.mainInfoBtns {\n  margin-top: 5px;\n  padding-top: 10.5px;\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n\n  @media (max-width: 1300px) {\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 21px;\n  }\n}\n\n.skeletonPhoto {\n  border-radius: 50%;\n}\n\n.skeletonTextWrapper {\n  width: calc(100% - 95px);\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n}\n\n.skeletonText {\n  width: 100%;\n  display: block;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainInfo": `mainInfo__vA3FT`,
	"mainInfoTitle": `mainInfoTitle__rU5rx`,
	"mainInfoFields": `mainInfoFields__gQwbv`,
	"mainInfoPhoto": `mainInfoPhoto__q51Lx`,
	"mainInfoRight": `mainInfoRight__D6qF5`,
	"mainInfoText": `mainInfoText__zhHvC`,
	"mainInfoTextName": `mainInfoTextName__onn8l`,
	"mainInfoTextRole": `mainInfoTextRole__f5bKQ`,
	"mainInfoBtns": `mainInfoBtns__obMcA`,
	"skeletonPhoto": `skeletonPhoto__PxiKP`,
	"skeletonTextWrapper": `skeletonTextWrapper__ddtL7`,
	"skeletonText": `skeletonText__uCbqg`
};
module.exports = ___CSS_LOADER_EXPORT___;
